import { ComponentView, View } from "binder"
import { BarcodeReaderViewModel } from "./barcodeReader-viewModel"
import { BarcodeFormat, DecodeHintType, BrowserMultiFormatReader, BrowserCodeReader } from "@zxing/library";
import { stringIsNullOrEmpty } from "src/common/utilities";
import Quagga from 'quagga';
import { InternalTransfer } from "src/erp/inventory/internalTransfer/internalTransferList/internalTransferList-viewModel";

export class BarcodeReaderView extends ComponentView<BarcodeReaderViewModel> {
    GetViewUniqueId(): string {
        return "V-ADF47E85-85A8-4666-9594-DAE5C898EA43"
    }
    loadHtml(): string {
        let element = require('./barcodeReader.html').default;
        let style = require('./barcodeReader.less');
        return element;
    }
    constructor() {
        super();
    }

    public set readcode(v: string) { this._readcode = v; } public get readcode(): string { return this._readcode; } private _readcode: string;
    public set text(v: string) { this._text = v; } public get text(): string { return this._text; } private _text: string;

    private _videoElement: HTMLVideoElement;
    public onRenderCompleted() {
        this._videoElement = this.firstlevelElement.querySelector('video');
    }
    // async log(){

    //     const stream = await navigator.mediaDevices.getUserMedia({
    //         video: {
    //             facingMode : 'environment',
    //             width:{ideal:1080}
    //         },
    //     });
    //     const [track] = stream.getVideoTracks();
    //     const capabilities = track.getCapabilities();
    //     const settings = track.getSettings();
    //     track.applyConstraints({
    //         facingMode : 'environment',
    //     });

    //     // console.log(track);
    //     // console.log(capabilities);
    //     // console.log(settings);
    //     this._videoElement.srcObject = stream;
    // }
    private quaggaReader;
    private codeReader;
    private handler;

    private shallOmit: boolean;
    newCodeReceived(code: string) {
        if (stringIsNullOrEmpty(code))
            return;
        if (this.shallOmit === true)
            return;
        this.shallOmit = true;

        this.readcode = code;

        setTimeout(() => {
            this.readcode = '';
            this.shallOmit = false;
        }, 2000);

    }

    async initialize() {
        // const stream = await navigator.mediaDevices.getUserMedia({
        //     video: {
        //         facingMode : 'environment',
        //         width:{ideal:1080},

        //     },
        //     audio :false
        // });
        // const [track] = stream.getVideoTracks();
        // track.applyConstraints({
        //     facingMode : 'environment',
        // });



        // const formats = [BarcodeFormat.QR_CODE,BarcodeFormat.CODE_39,BarcodeFormat.CODE_93,BarcodeFormat.EAN_13,BarcodeFormat.EAN_8];
        // const hints = new Map();
        // hints.set(DecodeHintType.POSSIBLE_FORMATS, formats);
        // const codeReader = new BrowserMultiFormatReader(hints);
        // this.codeReader = codeReader;

        // codeReader.decodeFromStream(stream,this._videoElement,(result,err)=>{
        //     if(result){
        //         console.log(result.getText());
        //         this.newCodeReceived(result.getText());
        //     }
        // });


        Quagga.init({
            inputStream: {
                constraints: {
                    facingMode: 'environment',
                    width: 1080,
                },
                name: "Live",
                type: "LiveStream",
                target: this.firstlevelElement.querySelector('#quagga-container'),
            },
            decoder: {
                readers: [
                    'code_128_reader'
                ],
            },
            locate: false
        }, err => {
            if (err) {
                console.log(err);
                return;
            } else {
                Quagga.start();
                this.handler = data => {

                    const errors: number[] = data.codeResult.decodedCodes
                        .filter(_ => _.error !== undefined)
                        .map(_ => _.error);
                    const median = this._getMedian(errors);
                    if (median < 0.10 && this.sanityCheck(data.codeResult.code))
                        this.newCodeReceived(data.codeResult.code);
                };
                Quagga.onDetected(this.handler);
                this.startZxing();
            }
        })
    }

    private _getMedian(arr: number[]): number {
        arr.sort((a, b) => a - b);
        const half = Math.floor(arr.length / 2);
        if (arr.length % 2 === 1) // Odd length
            return arr[half];
        return (arr[half - 1] + arr[half]) / 2.0;
    }
    private sanityCheck(s) {
        return s.toUpperCase().match(/^[0-9A-Za-z\s\-\.\/\\]+$/);
    }

    private realRun(video) {
        const formats = [BarcodeFormat.QR_CODE, BarcodeFormat.CODE_39, BarcodeFormat.CODE_93, BarcodeFormat.EAN_13, BarcodeFormat.EAN_8];
        const hints = new Map();
        hints.set(DecodeHintType.POSSIBLE_FORMATS, formats);
        const codeReader = new BrowserMultiFormatReader(hints);
        this.codeReader = codeReader;
        let stream = <any>video.srcObject;
        this._videoElement.src = stream;
        codeReader.decodeFromStream(stream, this._videoElement, (result, err) => {
            if (result) {
                console.log(result.getText());
                this.newCodeReceived(result.getText());
            }
        });
    }
    private startZxing() {
        let video = this.firstlevelElement.querySelector('#quagga-container').querySelector('video');
        if (video.currentTime > 0 && video.readyState > 2) {
            this.realRun(video);
        }
        video.onplaying = x => {
            this.realRun(video);
        }
    }

    disposeReaders() {
        try {
            Quagga.offDetected(this.handler);
            Quagga.stop();
        } catch (e) {
            console.warn("Quagga already stopped.");
        }

        this.codeReader?.reset?.();
        this.codeReader?.stopContinuousDecode?.();
        this.codeReader?.stopAsyncDecode?.();

        try {

            const video = this.firstlevelElement.querySelector('#quagga-container video') as HTMLVideoElement;
            if (video?.srcObject) {
                const stream = video.srcObject as MediaStream;
                stream.getTracks().forEach(track => track.stop());
                video.srcObject = null;
            }
        } catch {

        }
    }

    attachedToView(): void {
        this.checkToDispose();
        this.initialize();
    }
    checkToDispose() {
        setTimeout(() => {
            if (this.internalCheckToDispose() == false) {
                this.checkToDispose();
            }
        }, 1000);
    }

    internalCheckToDispose() {
        if (this.firstlevelElement.isConnected == false) {
            this.disposeReaders();
            return true;
        }
        return false;
    }
}
